// extracted by mini-css-extract-plugin
export default {"buttonAr":"X8zdy","visibled":"BwXHR","icon":"ljXHF","buttonText":"ZbcZc","button":"Qq9e2"};